import { all, fork } from "redux-saga/effects"

//public
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import brandsSaga from "./brands/saga"
import merchantsSaga from "./merchants/saga"
import merchantGroupSaga from "./merchant-group/saga"
import offersSaga from "./offers/saga"
import notificationsSaga from "./notifications/saga"
import userMenuSaga from "./auth/user-menu/saga"
import appInfoSaga from "./appInit/saga"
import usersSaga from "./users/saga"
import dashboardSaga from "./dashboard/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(brandsSaga),
    fork(merchantsSaga),
    fork(merchantGroupSaga),
    fork(offersSaga),
    fork(notificationsSaga),
    fork(userMenuSaga),
    fork(appInfoSaga),
    fork(usersSaga),
    fork(dashboardSaga),
  ])
}
